import { useState } from "react";
import update from "../../../api/auth/items/itemBookableDurations/update";
import { Checkbox } from "@mui/material";

export default function ItemBookableDurationActiveCheck({ itemBookableDuration}) {
  const [checked, setChecked] = useState(itemBookableDuration.active);

  const handleCheck = () => {
    update(itemBookableDuration.item_id, itemBookableDuration.id, { active: !checked }, () => {
      setChecked(!checked);
    }, () => {
    });
  };

  return (
    <Checkbox
      checked={checked}
      onChange={handleCheck}
    />
  );
}